import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./Utils/Redux/Store/store";
import { Provider } from "react-redux";
import "react-lazy-load-image-component/src/effects/blur.css";
import "slick-carousel/slick/slick.css";
import "./views/User/User.css";
import "slick-carousel/slick/slick-theme.css";
import { TimerProvider } from "./components/atoms/Timer/TimerContext";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <TimerProvider>
        <App />
      </TimerProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
